function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Mail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a1.5 1.5 0 011.5-1.5h17A1.5 1.5 0 0122 6v12a1.5 1.5 0 01-1.5 1.5h-17A1.5 1.5 0 012 18V6zm1.5-.5A.5.5 0 003 6v12a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V6a.5.5 0 00-.5-.5h-17zm1.093 2.21a.5.5 0 01.698-.117l6.418 4.585a.5.5 0 00.582 0l6.418-4.585a.5.5 0 11.582.814l-6.42 4.585a1.5 1.5 0 01-1.743 0L4.71 8.407a.5.5 0 01-.116-.698z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Mail);
export default ForwardRef;